import React from 'react';
import { ShimmerCircularImage } from 'react-shimmer-effects';

import './image.scss';

export const Image = ({
  width,
  height,
  src,
  className,
  style,
  icon,
  alt,
  circular = false,
  loading
}) => (
  <>
    {!!src && !loading && (
      <img
        alt={alt}
        src={src}
        className={`image ${circular ? 'image--circular' : ''} ${className}`}
        style={{ width, height, ...style }}
      />
    )}
    {!src && !loading && (
      <div className="image" style={{ width, height, ...style }}>
        {icon}
      </div>
    )}
    {loading && <ShimmerCircularImage size={width} />}
  </>
);
